module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="gererbadgeages-popup cw-fieldset">\r\n  <div class="phx-formTable">\r\n    <div class="form-group phx-formErrors ui-state-error"></div>\r\n    <div>\r\n      <div class="form-group">\r\n          <span class="spanComment"></span>\r\n      </div>\r\n      <div class="form-group">\r\n        <label for="commentaire">'+
((__t=(UTILS.getSVGIcon('bulle','',16)))==null?'':__t)+
''+
((__t=(i18n.t('common:gereronebadgeage.comment')))==null?'':__t)+
'</label>\r\n        <textarea class="commentaire form-control" maxlength="60" cols="30" rows="3"></textarea>\r\n      </div>\r\n      <div class="cwDialog-buttons cw-buttonBar">\r\n        <div class="btnBar-btn-container">\r\n          <button type="button" class="btnOK btn btn-primary btn-withIcon" value="btnOK">'+
((__t=(i18n.t('common:gereronebadgeage.btnOK')))==null?'':__t)+
' '+
((__t=(UTILS.getSVGIcon('valider','',16)))==null?'':__t)+
'</button>\r\n        </div>\r\n        <div class="btnBar-btn-container">\r\n          <button type="button" class="btnAnnuler btn btn-secondary btn-withIcon" value="btnAnnuler">'+
((__t=(i18n.t('common:gereronebadgeage.btnAnnuler')))==null?'':__t)+
' '+
((__t=(UTILS.getSVGIcon('croix','',16)))==null?'':__t)+
'</button>\r\n        </div>\r\n      </div>\r\n  </div>\r\n</fieldset>';
}
return __p;
};
